const config = {
    ARCHIREPORT_WEB_API_URL: process.env.REACT_APP_ARCHIREPORT_WEB_API_URL,
    TRANSLATION_BUCKET: process.env.REACT_APP_TRANSLATION_BUCKET,
    TRANSLATION_BUCKET_REGION: process.env.REACT_APP_TRANSLATION_BUCKET_REGION
};

export default config;
